package one.healthium.paywall.ui.scheduler

import one.healthium.domain.paywall.models.RemarketingOffer

actual class RemarketingScheduler {
    actual suspend fun schedule(offers: List<RemarketingOffer>) {
    }

    actual fun cancelAll() {
    }
}